
import { ref } from "vue";
import { generateSignePublicdUrl } from "@/api/storage"; 

const imageCache = new Map();

export function usePublicUrl(path) {
  const publicUrl = ref(imageCache.get(path) || "");

  if (!imageCache.has(path)) {
    generateSignePublicdUrl(path)
      .then(url => {
        publicUrl.value = url;
        imageCache.set(path, url);
        console.log("Public URL loaded:", url);
      })
      .catch(err => {
        console.error("Error fetching URL:", err);
      });
  }

  return publicUrl;
}